// authSlice.js

import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { baseCentralizeQuery } from '../../utils/API/fetchBaseQuery';

const ssoAPI = createApi({
    baseQuery: baseCentralizeQuery, // Replace with your API endpoint
    endpoints: (builder) => ({
        checkCookies: builder.query({
            query: () => ({
                url: `/Authentication/CheckCookies`,
                method: "GET",
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


    }),
});

export const { useLazyCheckCookiesQuery } = ssoAPI;
export default ssoAPI;
